import type { Router } from 'vue-router';

/**
 * Opens the "Biên bản kiểm nghiệm" PDF viewer page in a new browser tab.
 *
 * Shared so every "In BBKN" / print button behaves the same way (open the
 * viewer route instead of a print modal).
 */
export function openBienBanKiemNghiemPdf(
  router: Router,
  idBienBanKiemNghiem: number | string | null | undefined
): void {
  if (!idBienBanKiemNghiem) return;

  const route = router.resolve({
    name: 'xem-bien-ban-kiem-nghiem',
    params: { id: String(idBienBanKiemNghiem) },
  });

  window.open(route.href, '_blank');
}
